import { MutationTree } from 'vuex'
import UserState from './UserState'
import * as types from './mutation-types'

const mutations: MutationTree <UserState> = {
    [types.USER_TOKEN_CHANGED] (state, payload) {
        state.token = payload.newToken
    },
    [types.USER_END_SESSION] (state) {
      state.token = ''
      state.current = {}
      state.facilityLocationsByFacilityId = {},
      state.permissions = [],
      state.allNotificationPrefs = [],
      state.omsRedirectionInfo = {
        url: "",
        token: ""
      }
    },
    [types.USER_INFO_UPDATED] (state, payload) {
        state.current = payload
    },
    [types.USER_INSTANCE_URL_UPDATED] (state, payload) {
        state.instanceUrl = payload;
    },
    [types.USER_CURRENT_ECOM_STORE_UPDATED](state, payload) {
        state.currentEComStore = payload;
    },
    [types.USER_FACILITY_LOCATIONS_BY_FACILITY_ID] (state, payload) {
        state.facilityLocationsByFacilityId[payload.facilityId] = payload.facilityLocations;
    },
    [types.USER_PERMISSIONS_UPDATED] (state, payload) {
        state.permissions = payload
    },
    [types.USER_PWA_STATE_UPDATED](state, payload) {
        state.pwaState.registration = payload.registration;
        state.pwaState.updateExists = payload.updateExists;
    },
    [types.USER_OMS_REDIRECTION_INFO_UPDATED](state, payload) {
         state.omsRedirectionInfo = payload;
     },
    [types.USER_NOTIFICATIONS_UPDATED] (state, payload) {
        state.notifications = payload
    },
    [types.USER_NOTIFICATIONS_PREFERENCES_UPDATED] (state, payload) {
        state.notificationPrefs = payload
    },
    [types.USER_FIREBASE_DEVICEID_UPDATED] (state, payload) {
        state.firebaseDeviceId = payload
    },
    [types.USER_UNREAD_NOTIFICATIONS_STATUS_UPDATED] (state, payload) {
        state.hasUnreadNotifications = payload
    },
    [types.USER_ALL_NOTIFICATION_PREFS_UPDATED] (state, payload) {
        state.allNotificationPrefs = payload
    }, 
}
export default mutations;